﻿import { FunctionComponent } from "react";
import { BoxProps } from "@chakra-ui/react";
import { Shimmer, ShimmerProps } from "../Shimmer";

export const RepeatShimmer: FunctionComponent<BoxProps & ShimmerProps & { times: number }> = ({ times, ...props }) => {
    return (
        <>
            {new Array(times).fill(null).map((val, i) => (
                <Shimmer key={i} {...props} />
            ))}
        </>
    );
};
